export enum GlobalAction {
  StartFetching = 'START_FETCHING',
  FinishedFetching = 'FINISHED_FETCHING',
  ErrorFetching = 'ERROR_FETCHING',
  ClearState = 'CLEAR_STATE',
  SetError = 'SET_ERROR',
  SetModalAlert = 'SET_MODAL_ALERT',
  LoginInfo = 'LOGIN_INFO',
  AccessUser = 'ACCESS_USER',
  BranchOfficeSelected = 'BRANCH_OFFICE_SELECTED',
  ImpersonationStarted = 'IMPERSONATION_STARTED',
  ImpersonationEnded = 'IMPERSONATION_ENDED',
}
